import { Component, PropSync, Vue } from "vue-property-decorator";

// 特店 - 子項目 (每個特店資訊)
type Store = {
    id: number;
    code: string;
    name: string;
    selected: boolean;
};

// 特店 - 主項目 (統編號碼 + 全選)
type StoreGroup = {
    tidNumber: string;
    selected: boolean;
    storeList: Store[];
};

@Component<LBlist>({
    components: {},
})
export default class LBlist extends Vue {
    private tidNumber = "";
    private isSelectedCount = 0;
    private maxLimit = 800;
    

    // valid
    private isEmptyError = false;
    private isCountError = false;

    private onceSearch = true; // 只需要查詢一次

    // prop in
    @PropSync("storeGroupList", { type: Array })
    syncedStoreGroupList!: StoreGroup[];

    public created() {
        this.$parent?.$on("searchStore", (tidNumber: string, firstSearch: boolean) => {
            this.tidNumber = tidNumber;
            console.log(tidNumber);
            this.search();
        }); // 覆寫父層 加入一個自定義監聽的事件 event name(string), event
    }

    // event out
    private search() {
        if (!this.onceSearch) {
            return false;
        }

        this.onceSearch = false;

        this.$emit("getStoreList", this.tidNumber); // 觸發的事件名稱 + 事件參數
        this.tidNumber = ""; // reset
    }

    private close() {
        this.$emit("closeLBlist"); // 觸發的事件名稱
    }

    private submit() {
        this.hideErrorMsg();

        // 驗證數量 至少1間至多500間
        this.isSelectedCount = this.countCheckboxSelected();
        const nowSelectedCount = this.isSelectedCount;
        console.log('nowSelectedCount');
        console.log(nowSelectedCount);
        if (nowSelectedCount === 0) {
            this.isEmptyError = true;
            return false;
        } else if (nowSelectedCount > this.maxLimit) {
            this.isCountError = true;
            return false;
        }

        let submitType = 0; // 1 => 統一編號, 2 => 複選特店
        const storeByTidNumber = "";
        const tidNumberArr: string[] = [];
        const storeArr: string[] = [];

        let isSelectAll = false;
        this.syncedStoreGroupList.some((thisGroup) => {
            if (thisGroup.selected === true) {
                isSelectAll = true;
                return true;
            }
        });

        submitType = 2;
        Object.keys(this.syncedStoreGroupList).forEach((key, index) => {
            // key: string, index: number
            if(this.syncedStoreGroupList[index].selected === true){
                tidNumberArr.push(this.syncedStoreGroupList[index].tidNumber);
            }
            
            this.syncedStoreGroupList[index].storeList.forEach((thisStore) => {
                if (thisStore.selected) {
                    storeArr.push(thisStore.code);
                }
            });
        });

        console.log("storeArr");
        console.log(storeArr);
        console.log("tidNumberArr");
        console.log(tidNumberArr);

        this.$emit("selectStore", submitType, storeByTidNumber, storeArr, tidNumberArr); // 觸發的事件名稱
    }

    // 全選
    private selectAll(index: number) {
        let checkboxStatus = false;

        if (!this.syncedStoreGroupList[index].selected) {
            checkboxStatus = true;
        }

        this.syncedStoreGroupList[index].storeList.forEach((thisStore) => {
            thisStore.selected = checkboxStatus;
        });
    }

    // 子項目判斷全選
    private selectSub(index: number, childIndex: number) {
        const thisCheckboxStatus = this.syncedStoreGroupList[index].storeList[
            childIndex
        ].selected;

        // false 正要變成 true (空的變為勾選)
        if (!thisCheckboxStatus) {
            // 先賦予勾選true
            this.syncedStoreGroupList[index].storeList[childIndex].selected = true;

            let selectAllCheckboxStatus = true;
            this.syncedStoreGroupList[index].storeList.some((thisStore) => {
                if (!thisStore.selected) {
                    selectAllCheckboxStatus = false;
                    return true;
                }
            });
            this.syncedStoreGroupList[index].selected = selectAllCheckboxStatus;
        } else {
            this.syncedStoreGroupList[index].selected = false;
            this.syncedStoreGroupList[index].storeList[childIndex].selected = false;
        }
    }

    // 刪除
    private del(index: number) {
        this.syncedStoreGroupList.splice(index, 1);
    }

    private countCheckboxSelected() {
        let count = 0;
        this.syncedStoreGroupList.forEach(thisTidNumber => {
            thisTidNumber.storeList.forEach(thisStoreCode => {
                if (thisStoreCode.selected) {
                    count += 1;
                }
            })
        });

        return count;
    }

    private hideErrorMsg() {
        this.isEmptyError = false;
        this.isCountError = false;
    }    
}
